<template>
  <ViewCustomData entityName="role" entitySpec="data" serviceName="BaseService" :columns="ROLE_COLUMNS"
    scrollHeight="122px" :paginator="false" ref="viewRoleData" mode="edit"
    :requiredFieldsTable="{ role_sysname: true, role_name: true }" :prepareInsert="prepareInsert" />
</template>

<script setup>
import { ref } from 'vue';
import { ROLE_COLUMNS } from './userConstants';

const viewRoleData = ref(null);

const prepareInsert = (rowData) => {
  delete rowData.role_id;
  return rowData;
};

</script>